import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from "../auth.service";
import {distinctUntilChanged, map} from "rxjs/operators";
import {appRoutingEnum} from "@enums/appRoutingEnum";

@Injectable({
  providedIn: 'root'
})
export class NonPayingGuard implements CanActivate {
  private isSubscribed: boolean = true;
  private isAccountOld: boolean = false;
  private isStatus: boolean = false;

  constructor(private auth: AuthService, private router: Router) {
    auth.isAccountLessThan2DaysOld$
      .pipe(map(value => !value), distinctUntilChanged()).subscribe(value => {
      this.isAccountOld = value
    })
    auth.isPaying$
      .pipe(distinctUntilChanged()).subscribe(value => this.isSubscribed = value)
    auth.status$
      .pipe(map(status => !!status), distinctUntilChanged()).subscribe(value => {
      this.isStatus = value
    })
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.isSubscribed || !this.isAccountOld) {
      this.router.parseUrl(appRoutingEnum.HOME);
    }
    return this.auth.getIsPayingFromStorage().pipe(map(isPaying => isPaying ? this.router.parseUrl(appRoutingEnum.HOME) : true));
  }


}
